import React, { useContext, useState, useEffect } from 'react';
import Logo from './Logo';
import { GrSearch } from 'react-icons/gr';
import { FaUserCircle, FaShoppingCart } from 'react-icons/fa';
import { FaRegCircleUser } from "react-icons/fa6";
import { FiMenu } from 'react-icons/fi';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import { setUserDetails } from '../store/userSlice';
import ROLE from '../common/role';
import Context from '../context';

const Header = () => {
  const user = useSelector(state => state?.user?.user);
  const dispatch = useDispatch();
  const [menuDisplay, setMenuDisplay] = useState(false);
  const context = useContext(Context);
  const navigate = useNavigate();
  const searchInput = useLocation();
  const URLSearch = new URLSearchParams(searchInput?.search);
  const searchQuery = URLSearch.getAll('q');
  const [search, setSearch] = useState(searchQuery[0] || '');
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const [allCategories, setAllCategories] = useState([]);

  useEffect(() => {
    const fetchAllCategories = async () => {
      try {
        const response = await fetch(SummaryApi.getCategories.url);
        const dataResponse = await response.json();
        setAllCategories(dataResponse?.data || []);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchAllCategories();
  }, []);

  const handleLogout = async () => {
    const fetchData = await fetch(SummaryApi.logout_user.url, {
      method: SummaryApi.logout_user.method,
      credentials: 'include',
    });
    const data = await fetchData.json();
    if (data.success) {
      toast.success(data.message);
      dispatch(setUserDetails(null));
      navigate('/');
    }
    if (data.error) {
      toast.error(data.message);
    }
  };

  const handleSearch = e => {
    const { value } = e.target;
    setSearch(value);
    if(value){
      navigate(`/search?q=${value}`)
    }else{
      navigate("/search")
    }
  };

  return (
    <header className='h-16 shadow-md bg-rose-700 fixed w-full max-w-[100vw] z-40 border-blue-600'>
     <div className=' h-full container mx-auto flex items-center justify-between gap-3 px-4 py-2 relative overflow-visible overflow-x-auto overflow-y-auto'>

  {/* LEFT: Category Icon & Logo */}
  <div className='flex items-center gap-3 min-w-fit'>

    {/* Category Icon */}
    <div className='relative'>
      <button
        onClick={() => setOpen(!open)}
        className='text-white px-2 py-1 text-xl rounded-md flex items-center'
        aria-label='Open Categories'
      >
        <FiMenu />
      </button>
    </div>

    {/* Logo */}
    <div className='flex items-center px-2 py-1 rounded-full min-w-fit'>
      <Link to='/' className='rounded-full hidden sm:flex items-center gap-1'>
        <Logo w={30} h={16} alt='Bellan Logo' />
        <p className='text-lg font-bold text-white hidden sm:block whitespace-nowrap'>Purchase Palace</p>
      </Link>
    </div>
  </div>

  {/* CENTER: Search Bar */}
  <div className='flex-1 flex justify-center min-w-0'>
    <div className='flex items-center w-full max-w-[350px] border border-white rounded-full px-2'>
      <input
        type='text'
        placeholder='Search...'
        className='w-full px-2 py-1 text-sm outline-none bg-transparent text-white placeholder-white truncate'
        onChange={handleSearch}
        value={search}
      />
      <div className='text-md min-w-[35px] h-8 flex items-center justify-center rounded-full text-white'>
        <GrSearch />
      </div>
    </div>
  </div>

  {/* RIGHT: User / Cart / Login */}
  <div className='flex items-center gap-7 h-full overflow-hidden'>
    <div className='relative flex justify-center h-full overflow-hidden'>
                    {
                    user?._id && (
                      <div className='text-3xl cursor-pointer relative flex justify-center' onClick={()=>setMenuDisplay(preve => !preve)}>
                        {
                          user?.profilePic ? (
                            <img src={user?.profilePic} className='w-8 h-8 rounded-full' alt={user?.name} />
                          ) : (
                            <FaRegCircleUser/>
                          )
                        }
                      </div>
                    )
                  }
                  
                
       
                  
                  
                  {
                    menuDisplay && (
                      <div className='fixed top-16 right-4 z-[999] bg-white p-2 shadow-lg rounded w-40' >
                        <nav>
                          {
                            user?.role === ROLE.ADMIN && (
                              <Link to={"/admin-panel/all-products"} className='whitespace-nowrap block hover:bg-slate-100 p-2' onClick={()=>setMenuDisplay(preve => !preve)}>Admin Panel</Link>
                            )
                          }
                         
                        </nav>
                      </div>
                    )
                  }
                 
              
    </div>

                  {
                     user?._id && (
                      <Link to={"/cart"} className='text-2xl relative'>
                          <span><FaShoppingCart/></span>
      
                          <div className='bg-red-600 text-white w-5 h-5 rounded-full p-1 flex items-center justify-center absolute -top-2 -right-3'>
                              <p className='text-sm'>{context?.cartProductCount}</p>
                          </div>
                      </Link>
                      )
                  }
              


                <div>
                  {
                    user?._id  ? (
                      <button onClick={handleLogout} className='px-3 py-1 rounded-full text-white bg-red-600 hover:bg-red-700'>Logout</button>
                    )
                    : (
                    <Link to={"/login"} className='px-3 py-1 rounded-full text-white bg-red-600 hover:bg-red-700'>Login</Link>
                    )
                  }
                    
                </div>
            </div>


  {/* CATEGORIES DROPDOWN — MOVED OUTSIDE FLEX CONTAINER */}
{/* Fullscreen Category Popup */}
{open && (
  <div className="fixed inset-0 z-50 bg-black bg-opacity-70 flex items-center justify-center">
    <div className="bg-white w-[90%] max-w-md max-h-[80vh] overflow-y-auto rounded-lg shadow-lg p-4 relative">
      <button
        className="absolute top-2 right-2 text-black text-2xl"
        onClick={() => setOpen(false)}
      >
        &times;
      </button>
      <h2 className="text-xl font-semibold mb-4 text-center text-rose-700">Purchase Palace Categories</h2>
      {allCategories.length > 0 ? (
        allCategories.map(cat => (
          <div key={cat._id} className="mb-3">
            <Link
              to={`/search?q=${cat.categoryName}`}
              className="text-lg font-medium text-rose-800 hover:underline block"
              onClick={() => setOpen(false)}
            >
              {cat.categoryName}
            </Link>
            {cat?.subCategories?.length > 0 && (
              <div className="pl-4 mt-1">
                {cat.subCategories.map((sub, i) => (
                  <Link
                    key={i}
                    to={`/search?q=${sub.toLowerCase()}`}
                    className="block text-sm text-gray-600 hover:text-rose-600"
                    onClick={() => setOpen(false)}
                  >
                    - {sub}
                  </Link>
                ))}
              </div>
            )}
          </div>
        ))
      ) : (
        <p className="text-gray-600 text-center">No categories found</p>
      )}
    </div>
  </div>
)}

</div>


    </header>
  );
};

export default Header; 
